import React, { useState } from "react"
import { Link } from "gatsby"
import { NavigationItem } from "./navigation"

interface MenuItemProps {
  item: NavigationItem
  clickCallback: (e: React.MouseEvent<HTMLElement>) => void
}

const MenuItem = ({ item, clickCallback }: MenuItemProps) => {
  const [expanded, setExpanded] = useState(false)
  const expandable = item.links && item.links.length > 0

  if (!item.url) {
    return null
  }

  return (
    <div className={`c-menu__item${expanded ? " -expanded" : ""}`}>
      <Link to={item.url} onClick={clickCallback}>
        {item.heading || item.title}
      </Link>
      {expandable && (
        <button
          className="c-menu__item-expand"
          onClick={() => setExpanded(!expanded)}
          aria-controls={`menu-item-${item.id}`}
          aria-expanded={expanded}
        >
          <span className="u-visually-hidden">
            {expanded ? "Collapse" : "Expand"}
          </span>
        </button>
      )}
      {expanded && (
        <div id={`menu-item-${item.id}`} className="c-menu__children">
          {item.links?.map(item => {
            if (item) {
              return (
                <MenuItem
                  key={item.id}
                  item={item}
                  clickCallback={clickCallback}
                />
              )
            }
          })}
        </div>
      )}
    </div>
  )
}
export default MenuItem
